package de.geomobile.common.filter


abstract class FilterListBuilder<ELEMENT>(private vararg val filter: Filter<ELEMENT, *>) {
    val filters = filter.associateBy { it.id }
}